<template>
  <div class="mini-logo text-center my-4">
    <router-link to="/intro"
      ><img src="../../assets/images/logo.png" alt=""
    /></router-link>
    <h4 class="card-title mt-3">{{ title }}</h4>
  </div>
</template>

<script>
export default {
  name: "AuthHeader",
  props: {
    title: String,
  },
};
</script>
